// extracted by mini-css-extract-plugin
export var callCard = "_nr-0";
export var callMessageButton = "_nr-1";
export var helpIcon = "_nr-3";
export var helpIconContainer = "_nr-4";
export var verticalDivider = "_nr-2";